import { faSearch } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { bool, string } from "prop-types";
import { MessageWrapper } from "./styled";

const SearchResultsMessage = ({ message = "No Results", show = false }) => {
  if (!show) return null;

  return (
    <MessageWrapper>
      <FontAwesomeIcon icon={faSearch} />
      <br />
      <h3>{message}</h3>
    </MessageWrapper>
  );
};

SearchResultsMessage.propTypes = {
  message: string,
  show: bool,
};

export default SearchResultsMessage;
